import React from 'react'
import cn from 'classnames'
import { ListItem, Menu } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import { ReactComponent as CheckedIcon } from 'assets/img/management-checked.svg'
import messages from '../../ManagementUI/translate'

function SingleSelectDropdown({
  intl: { formatMessage },
  anchor,
  onCloseMenu,
  arr,
  selectedValue,
}) {
  return (
    <Menu
      anchorEl={anchor}
      open={!!anchor}
      onClose={() => {
        onCloseMenu()
      }}
      className="management-ui-menu"
      PaperProps={{
        style: { maxHeight: '400px' },
      }}>
      {arr.map(({ label, value }) => {
        const isSelected = value === selectedValue

        return (
          <ListItem
            key={value}
            className={cn('menu-item wide', { active: isSelected })}
            onClick={() => {
              if (!isSelected) {
                onCloseMenu(value)
              }
            }}>
            <div className="text">{formatMessage(messages[label])}</div>
            {isSelected && <CheckedIcon />}
          </ListItem>
        )
      })}
    </Menu>
  )
}

export default injectIntl(SingleSelectDropdown)
